<template>
  <v-container>
    <gridView v-if="edit" @editItem="editItem" />
    <formView v-else :identifier="identifier" @editItem="editItem" />
  </v-container>
</template>

<script>
import gridView from './grid'
import formView from './form'

export default {
  name: 'credential',

  data: () => ({
    edit: true,
    identifier: ''
  }),

  components: {
    gridView,
    formView
  },

  methods: {
    editItem (boolean, item) {
      this.edit = boolean
      this.identifier = item?.serverName
    }
  }
}
</script>
